import React, { useState } from 'react';
import { TextField, InputAdornment } from '@mui/material';
import {Clear, Search} from '@mui/icons-material';
import { I18n } from 'aws-amplify/utils';
import IconButton from "@mui/material/IconButton";
import PropTypes from "prop-types";

/**
 * @typedef {object} SearchBarProps
 * @property {string} id
 * @property {string} [className]
 * @property {string} [label]
 * @property {'outlined' | 'filled' | 'standard'} [variant]
 * @property {'small' | 'medium'} [size]
 * @property {(event: React.ChangeEvent<HTMLInputElement>) => void} onChange
 * @property {() => void} onClear
 */

/**
 * Champ de recherche réutilisable avec effacement immédiat de la saisie.
 * @param {SearchBarProps} props
 */
const SearchBar = ({
    id,
    className = "search-field-expand",
    label = I18n.get('DEFAULT_FILTER'),
    variant = "outlined",
    size = "small",
    onChange,
    onClear
}) => {
    const [currentSearch, setCurrentSearch] = useState('');

    const handleChange = event => {
        setCurrentSearch( event.target.value );
        onChange( event );
    };

    const handleClear = () => {
        setCurrentSearch( '' );
        onClear();
    };

    return (
        <TextField
            id={id}
            className={className}
            autoComplete="off"
            value={currentSearch}
            label={label}
            variant={variant}
            size={size}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <Search />
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            size="small"
                            edge="end"
                            onClick={handleClear}
                        >
                            <Clear fontSize="small" />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            onChange={handleChange}
        />
    );
};

SearchBar.propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    label: PropTypes.string,
    variant: PropTypes.string,
    size: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired
};

export default SearchBar;
